type BrandIdentityProps = {
  className?: string;
};

const brandMarkSrc = `${process.env.PUBLIC_URL || ""}/brand-mark.png`;

export function BrandMark({ className = "" }: BrandIdentityProps) {
  return (
    <span className={`haulledger-brand-mark ${className}`} aria-hidden="true">
      <img src={brandMarkSrc} alt="" />
    </span>
  );
}

export function BrandWordmark({ className = "" }: BrandIdentityProps) {
  return <span className={`haulledger-wordmark ${className}`}>HaulLedger</span>;
}
